/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {useDispatch} from 'react-redux'
import {setTitle} from '../../redux/reducers/mainSlice'
import useUtils from './useUtils'
import Papa from 'papaparse'
import {unparse} from 'papaparse'
import clsx from 'clsx'
import {Dropdown} from 'react-bootstrap'
import ViewVideo from './ViewVideo'
import Pagination from '../../modules/pagination/Pagination'
import VideoListSk from '../../modules/skeleton/VideolistSK'
import saveAs from 'file-saver'
import CSVModal from '../../modules/modal/CSVModal'
import {showAlert} from '../../redux/reducers/alertSlice'
import {useHelper} from '../../../_metronic/helpers/useHelper'
import CustomFilterDropdown from '../../modules/common/CustomFilterDropdown'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import reloadIcon from '../../../_metronic/assets/custom-icons/reload.png'
import DeleteConfirmation from '../../modules/alert/DeleteConfirmation'

const VideoGridView = ({className, close}) => {
  const {
    fetchProgram,
    submitReport,
    fetchCourse,
    fetchModule,
    fetchUnit,
    fetchVideos,
    deleteVideo,
    handleEdit,
    addCSV,
    fetchAllVideos,
    refetchVideo,
    getVideo
  } = useUtils()
  const fileInputRef = useRef(null)
  const [searchTerm, setSearchTerm] = useState()
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(true)
  const [retryLoading, setRetryLoading] = useState(false)
  const [id, setId] = useState(null)
  const [videoLink, setVideoLink] = useState(null)
  const [uploadLoading, setUploadLoading] = useState(false)
  const previousSearchTerm = useRef('')
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(12)
  const [totalPages, setTotalPages] = useState(1)
  const [videos, setVideos] = useState()
  const [isOpen, setIsOpen] = useState(false)
  const [csvData, setcsvData] = useState(null)
  const [isUpload, setIsUpload] = useState(false)

  const [selectedProgram, setSelectedProgram] = useState(null)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [selectedModule, setSelectedModule] = useState(null)
  const [selectedUnit, setSelectedUnit] = useState(null)

  const [programOptions, setProgramOptions] = useState([])
  const [courseOptions, setCourseOptions] = useState([])
  const [moduleOptions, setModuleOptions] = useState([])
  const [unitOptions, setUnitOptions] = useState([])

  const [programNextPageToken, setProgramNextPageToken] = useState(null)
  const [courseNextPageToken, setCourseNextPageToken] = useState(null)
  const [moduleNextPageToken, setModuleNextPageToken] = useState(null)
  const [unitNextPageToken, setUnitNextPageToken] = useState(null)

  const [isLoadingPrograms, setIsLoadingPrograms] = useState(false)
  const [isLoadingCourses, setIsLoadingCourses] = useState(false)
  const [isLoadingModules, setIsLoadingModules] = useState(false)
  const [isLoadingUnits, setIsLoadingUnits] = useState(false)

  const [modalVisible, setModalVisible] = useState(false)
  const [selectedVideoId, setSelectedVideoId] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  dispatch(setTitle('Video'))

  const getVideos = async () => {
    try {
      if (searchTerm === previousSearchTerm.current) {
        setLoading(true)
      }
      const offset = (page - 1) * limit
      const videoData = await fetchVideos(
        searchTerm,
        limit,
        offset,
        selectedProgram,
        selectedCourse,
        selectedModule,
        selectedUnit
      )
      setVideos(videoData)
      setTotalPages(Math.ceil(videoData.count / limit))
      previousSearchTerm.current = searchTerm
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleReload = async(id) => {
    try{
      setRetryLoading(true)
      setId(id)
      const response = await refetchVideo(id) 
      if(response){
        setVideos((prevVideos) => {
          const updatedRecords = prevVideos.records.map((video) => {
            if (video.id === id) {
              return {...video, status: response.status, errorMessage: response.errorMessage}
            }
            return video
          })
          return {...prevVideos, records: updatedRecords}
        })
      }
    }catch (error) {}
    finally{
      setRetryLoading(false)
      setId(null)
    }
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(
      () => {
        getVideos()
      },
      searchTerm ? 500 : 0
    )
    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, page, limit, selectedProgram, selectedCourse, selectedModule, selectedUnit])

  const loadMorePrograms = async () => {
    if (isLoadingPrograms || !programNextPageToken) return

    setIsLoadingPrograms(true)
    try {
      const response = await fetchProgram(programNextPageToken)
      if (response) {
        setProgramOptions((prev) => [...prev, ...response.records])
        setProgramNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more programs:', error)
    } finally {
      setIsLoadingPrograms(false)
    }
  }

  const loadMoreCourses = async () => {
    if (isLoadingCourses || !courseNextPageToken || !selectedProgram) return

    setIsLoadingCourses(true)
    try {
      const response = await fetchCourse(selectedProgram, courseNextPageToken)
      if (response) {
        setCourseOptions((prev) => [...prev, ...response.records])
        setCourseNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more courses:', error)
    } finally {
      setIsLoadingCourses(false)
    }
  }

  const loadMoreModules = async () => {
    if (isLoadingModules || !moduleNextPageToken || !selectedCourse) return

    setIsLoadingModules(true)
    try {
      const response = await fetchModule(selectedCourse, moduleNextPageToken)
      if (response) {
        setModuleOptions((prev) => [...prev, ...response.records])
        setModuleNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more modules:', error)
    } finally {
      setIsLoadingModules(false)
    }
  }

  const loadMoreUnits = async () => {
    if (isLoadingUnits || !unitNextPageToken || !selectedModule) return

    setIsLoadingUnits(true)
    try {
      const response = await fetchUnit(selectedModule, unitNextPageToken)
      if (response) {
        setUnitOptions((prev) => [...prev, ...response.records])
        setUnitNextPageToken(response.nextPageToken)
      }
    } catch (error) {
      console.error('Error loading more units:', error)
    } finally {
      setIsLoadingUnits(false)
    }
  }

  const fetchInitialData = async () => {
    try {
      const programs = await fetchProgram()
      if (programs) {
        setProgramOptions(programs.records)
        setProgramNextPageToken(programs.nextPageToken)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  useEffect(() => {
    fetchInitialData()
  }, [])

  const handleProgramChange = async (programId) => {
    setSelectedProgram(programId)
    setSelectedCourse(null)
    setSelectedModule(null)
    setSelectedUnit(null)

    setCourseOptions([])
    setCourseNextPageToken(null)
    setModuleOptions([])
    setModuleNextPageToken(null)
    setUnitOptions([])
    setUnitNextPageToken(null)

    if (programId) {
      setIsLoadingCourses(true)
      try {
        const courses = await fetchCourse(programId)
        if (courses) {
          setCourseOptions(courses.records)
          setCourseNextPageToken(courses.nextPageToken)
        }
      } catch (error) {
        console.error('Error loading courses:', error)
      } finally {
        setIsLoadingCourses(false)
      }
    }
  }

  const handleCourseChange = async (courseId) => {
    setSelectedCourse(courseId)
    setSelectedModule(null)
    setSelectedUnit(null)

    setModuleOptions([])
    setModuleNextPageToken(null)
    setUnitOptions([])
    setUnitNextPageToken(null)

    if (courseId) {
      setIsLoadingModules(true)
      try {
        const modules = await fetchModule(courseId)
        if (modules) {
          setModuleOptions(modules.records)
          setModuleNextPageToken(modules.nextPageToken)
        }
      } catch (error) {
        console.error('Error loading modules:', error)
      } finally {
        setIsLoadingModules(false)
      }
    }
  }

  const handleModuleChange = async (moduleId) => {
    setSelectedModule(moduleId)
    setSelectedUnit(null)

    setUnitOptions([])
    setUnitNextPageToken(null)

    if (moduleId) {
      setIsLoadingUnits(true)
      try {
        const units = await fetchUnit(moduleId)
        if (units) {
          setUnitOptions(units.records)
          setUnitNextPageToken(units.nextPageToken)
        }
      } catch (error) {
        console.error('Error loading units:', error)
      } finally {
        setIsLoadingUnits(false)
      }
    }
  }

  const handleUnitChange = async (unitId) => {
    setSelectedUnit(unitId)
  }

  const onEdit = async (id) => {
    const values = await handleEdit(id)
    navigate('/videolist/editvideo', {state: {values}})
  }

  const onDelete = (id) => {
    setSelectedVideoId(id)
    setModalVisible(true)
  }

  const confirmDelete = async () => {
    if (!selectedVideoId) return
    try {
      const response = await deleteVideo(selectedVideoId)
      setVideos(response)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setModalVisible(false)
      setSelectedVideoId(null)
    }
  }

  const handleShow = (link) => {
    setShow(true)
    setVideoLink(link)
  }

  const handleDownload = async () => {
    try {
      setDownloadLoading(true)
      const data = await fetchAllVideos(
        searchTerm,
        selectedProgram,
        selectedCourse,
        selectedModule,
        selectedUnit
      )
      const csv = unparse(data, {header: true})
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      saveAs(blob, 'videos.csv')
    } catch (error) {
      console.error('Error downloading videos:', error)
    } finally {
      setDownloadLoading(false)
    }
  }

  const uploadFile = async (data) => {
    let successRecords = 0
    const failedRecords = []
    try {
      if (data.length <= 100) {
        const response = await addCSV(data)
        if (response) {
          if (response.success) {
            console.log(response.success)
            successRecords += response.success
          }
          if (response.failed?.length > 0) {
            failedRecords.push(...response.failed) // Push failed records
          }

          const successMessage = response.success
            ? `${successRecords} videos uploaded successfully`
            : ''
          const failedMessage =
            response.failed?.length > 0 ? `${response.failed.length} videos failed to upload` : ''
          const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
          dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))
        }
      } else {
        const chunkSize = 100
        const chunks = []
        for (let i = 0; i < data.length; i += chunkSize) {
          chunks.push(data.slice(i, i + chunkSize))
        }
        const uploadPromises = chunks.map((chunk) => addCSV(chunk))
        const responses = await Promise.all(uploadPromises)

        responses.forEach((response) => {
          if (response.success) {
            successRecords += response.success
          }
          if (response.failed?.length > 0) {
            failedRecords.push(...response.failed) // Aggregate failed records
          }
        })

        const successMessage = successRecords
          ? `${successRecords} videos uploaded successfully`
          : ''
        const failedMessage = failedRecords.length
          ? `${failedRecords.length} videos failed to upload`
          : ''
        const combinedMessage = [successMessage, failedMessage].filter(Boolean).join('. ')
        dispatch(showAlert({message: combinedMessage, variant: 'info', timeout: 5000}))
      }

      // Save final summary if there are failed records

      const finalSummary = {
        recordType: 'Videos',
        totalRecords: data.length,
        successRecords: successRecords,
        failedRecords: failedRecords,
      }

      const res = await submitReport(finalSummary)
      if (res) {
        dispatch(
          showAlert({message: 'Report Submitted Successfully', variant: 'info', timeout: 5000})
        )
      } else {
        console.log('Error')
      }
    } catch (error) {
      console.error('Error uploading course:', error)
    } finally {
      setUploadLoading(false)
    }
  }

  const handleFileChange = (event) => {
    setUploadLoading(true)
    const file = event.target.files[0]
    if (file) {
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        Papa.parse(file, {
          header: true,
          complete: (result) => {
            setIsOpen(true)
            setcsvData(result?.data)
            event.target.value = null
          },
          error: (error) => {
            console.error('Error parsing CSV:', error)
          },
        })
      } else {
        dispatch(showAlert({message: 'Please select a valid CSV file.', variant: 'danger'}))
      }
    }
  }

  useEffect(() => {
    if (csvData) {
      const transformedData = csvData?.map((obj, index) => ({
        id: obj?.id,
        title: obj?.title,
        link: obj?.link,
        description: obj?.description,
        tags: obj.tags ? obj.tags.split(',').map((tag) => tag.trim()) : [],
        duration: parseInt(obj?.duration) || 0,
        status: obj?.status,
        unitId: obj?.unit,
        languageId: obj?.language,
      }))

      const dataToUpload = transformedData.slice(0, -1)

      uploadFile(dataToUpload)
      setcsvData(null)
      getVideos()
    }
  }, [isUpload])

  useEffect(() => {}, [courseOptions])
  if (loading) return <VideoListSk />

  return (
    <>
      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start '>
            <span className=' mt-1 text-muted fs-7 '>
              {videos?.count} {videos?.count <= 1 ? 'Item' : 'items'}
            </span>
          </h3>
          {/* begin::Search */}
          <div className='d-flex align-items-center justify-content-between w-100 flex-wrap'>
            <div className='d-flex align-items-center flex-wrap gap-3'>
              <div className='d-flex align-items-center'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-1 position-absolute ms-6'
                />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid fs-7 w-250px ps-14'
                  placeholder='Search Videos'
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value)
                    setPage(1)
                  }}
                />
                {/* end::Search */}
              </div>

              <div>
                <CustomFilterDropdown
                  options={programOptions}
                  selectedValue={selectedProgram}
                  onChange={handleProgramChange}
                  onScrollEnd={loadMorePrograms}
                  isLoading={isLoadingPrograms}
                  placeholder='Select Program'
                  displayField='title'
                />
              </div>

              {selectedProgram && (
                <div>
                  <CustomFilterDropdown
                    options={courseOptions}
                    selectedValue={selectedCourse}
                    onChange={handleCourseChange}
                    onScrollEnd={loadMoreCourses}
                    isLoading={isLoadingCourses}
                    placeholder='Select Course'
                    displayField='title'
                  />
                </div>
              )}

              {selectedCourse && (
                <div>
                  <CustomFilterDropdown
                    options={moduleOptions}
                    selectedValue={selectedModule}
                    onChange={handleModuleChange}
                    onScrollEnd={loadMoreModules}
                    isLoading={isLoadingModules}
                    placeholder='Select Module'
                    displayField='title'
                  />
                </div>
              )}

              {selectedModule && (
                <div>
                  <CustomFilterDropdown
                    options={unitOptions}
                    selectedValue={selectedUnit}
                    onChange={handleUnitChange}
                    onScrollEnd={loadMoreUnits}
                    isLoading={isLoadingUnits}
                    placeholder='Select Unit'
                    displayField='name'
                  />
                </div>
              )}
            </div>
            <div className='card-toolbar'>
              <img
                src={toAbsoluteUrl('media/icons/duotune/files/fil001.svg')}
                className='me-5'
                onClick={() => close()}
                style={{cursor: 'pointer', height: '24px', width: '24px'}}
                title="Switch to List View"
              />
              <div>
                <span
                  onClick={() => fileInputRef.current.click()}
                  className='btn btn-sm btn-light-primary me-2'
                >
                  {uploadLoading ? (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/files/fil010.svg' className='svg-icon-2' />
                      Upload CSV
                    </>
                  )}
                </span>
                <input
                  type='file'
                  ref={fileInputRef}
                  style={{display: 'none'}}
                  accept='.csv'
                  onChange={handleFileChange}
                />
              </div>

              <span onClick={() => handleDownload()} className='btn btn-sm btn-light-primary me-2'>
                {downloadLoading ? (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : (
                  <>
                    <KTSVG
                      path='/media/icons/duotune/files/fil003.svg'
                      className='svg-icon-2 me-1'
                    />
                    Download CSV
                  </>
                )}
              </span>

              <span
                onClick={() => navigate('/videolist/addvideo')}
                className='btn btn-sm btn-light-primary'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                Add Video
              </span>
            </div>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}

        {videos?.count === 0 && (
          <div className='mt-20 mb-20 w-sm-100 w-md-75 mx-auto p-5 py-20'>
            <div className='card-body text-center'>
              <span className='svg-icon svg-icon-2hx svg-icon-info mb-5'>
                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x' />
              </span>
              <h4 className='mb-1'>No Records Found</h4>
              <span>Add more Videos or change the filters</span>
            </div>
          </div>
        )}

        {videos?.count > 0 && (
          <div
            className={clsx(
              'card-body py-10 d-flex',
              videos?.count <= 2 ? 'justify-content-start' : 'justify-content-center'
            )}
          >
            <div className='mt-3 d-flex justify-content-center align-items-start gap-10 flex-wrap'>
              {videos?.records?.length > 0 &&
                videos?.records?.map((val, index) => (
                  <div
                    className='shadow-lg overflow-hidden  position-relative bg-white text-black'
                    key={index}
                    style={{width: '220px', borderRadius: '9px'}}
                  >
                    <div className='player-wrapper position-relative'>
                      <img
                        src={val?.thumbnailUrl || 'https://placehold.co/220x160?text=Loading'}
                        onClick={() => handleShow(val.link)}
                        alt='video thumbnail'
                        style={{width: '100%', height: '160px', objectFit: 'cover'}}
                      />
                      <div
                        className='icon-overlay position-absolute'
                        style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}
                      ></div>
                    </div>
                    <div
                      className='card-toolbar m-0'
                      style={{position: 'absolute', zIndex: 1, top: '4px', right: '25px'}}
                    >
                      <Dropdown style={{background: 'transparent'}}>
                        <Dropdown.Toggle
                          className='selection'
                          variant='secondary'
                          id='dropdown-status'
                        >
                          <button
                            type='button'
                            className='btn btn-clean btn-sm btn-icon btn-icon-primary bg-white h-auto w-auto p-1'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen025.svg'
                              className='svg-icon-3 svg-icon-primary'
                            />
                          </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => onEdit(val.id)}>Edit</Dropdown.Item>
                          <Dropdown.Item onClick={() => onDelete(val.id)}>Delete</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <hr className='hr' />
                    <div className='px-2' style={{height: '90px'}}>
                      <div className='fw-bold fs-7 d-flex justify-content-between align-items-center'>
                        {val?.title?.length > 28 ? val.title.slice(0, 28) + ' ....' : val.title}

                        {(val.status === 'pending' || val.status === 'warning') && val.errorMessage && (
                          <div className='d-flex gap-1 align-items-center'>
                            <OverlayTrigger
                              placement='top'
                              overlay={
                                <Tooltip id={`tooltip-pending-${val.id}`}>
                                  {val.errorMessage}
                                </Tooltip>
                              }
                            >
                              <span className='ms-2' style={{cursor: 'pointer', color: '#FFA500'}}>
                                <KTSVG
                                  path='/media/icons/duotune/general/gen044.svg'
                                  className={`svg-icon-1 ${val.status === 'pending' ? 'text-danger' : 'text-warning'}`}
                                />
                              </span>
                            </OverlayTrigger>
                            {retryLoading&& val.id === id?
                            (
                              <div className='spinner-border spinner-border-sm align-middle ms-2'></div>
                            ):(<img className='cursor-pointer' onClick={()=>handleReload(val.id)} src={reloadIcon} style={{height:'19px'}}/>)}
                          </div>
                        )}
                      </div>
                      <div className='mb-3 text-start fs-8 fw-light mt-2'>
                        {val?.description?.length > 90
                          ? val.description.slice(0, 90) + ' ....'
                          : val.description}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {/* begin::Body */}
        <div className='d-flex align-items-center justify-content-between pb-5 ps-10 pe-5'>
          <div className='d-flex align-items-center gap-3'>
            <span className='fs-6 text-muted'>Show</span>
            <div>
              <select
                defaultValue={limit}
                className='form-select form-select-solid text-muted select2-hidden-accessible'
                onChange={(e) => {
                  setPage(1)
                  setLimit(e.target.value)
                }}
              >
                <option>12</option>
                <option>40</option>
                <option>80</option>
                <option>100</option>
              </select>
            </div>
          </div>
          {isOpen && (
            <CSVModal
              show={isOpen}
              upload={() => setIsUpload((prev) => !prev)}
              handleClose={() => {
                setIsOpen(false)
                setUploadLoading(false)
              }}
              handleCancel={() => {
                setIsOpen(false)
                setUploadLoading(false)
              }}
              csvData={csvData}
              optionalFields={['description', 'status']}
            />
          )}
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
        </div>
      </div>
      <ViewVideo show={show} onHide={() => setShow(false)} videoLink={videoLink} />
      <DeleteConfirmation
        isVisible={modalVisible}
        message="Are you sure you want to delete this video?"
        onConfirm={confirmDelete}
        onCancel={() => setModalVisible(false)}
      />
    </>
  )
}

export default VideoGridView 